import React from "react";
import "./Heading02.scss";

function Heading02({ children = "Default Text" }) {
  return (
    <div className="heading02">
      <div>{children}</div>
    </div>
  );
}

export default Heading02;
